module.exports = __webpack_public_path__ + "static/media/29FUNOV15.613c69e6.jpg";